export const state = {
    hasActiveDropdown: false,
};
